<!-- <ngx-loading-bar [color]="'#ec8951'" [includeSpinner]="false" [height]="'3px'"></ngx-loading-bar> -->
<router-outlet></router-outlet>
